import React from "react";

import { useTranslation } from "utils";

import { MODULE_COUNT } from "consts";

import { Module } from "models";

import { Icon, ModuleIconStatus } from "components";

type ModuleIconStatusPanelProps = {
  alignRight?: boolean;
  locked?: boolean;
  modules: Module[];
};

export const ModuleIconStatusPanel = ({ alignRight, locked, modules }: ModuleIconStatusPanelProps) => {
  const { t } = useTranslation("modules");

  const getPanel = () => {
    if (locked) {
      return (
        <div className="unlock">
          <Icon iconName="tabler/lock" className="icon inline margin-right-25" />
          <span>{t("moduleIconStatus.unlock")}</span>
        </div>
      );
    }

    if (!modules?.length) {
      return <span className="paragraph-xs">{t("moduleIconStatus.noModules")}</span>;
    }

    return modules
      .filter((module) => !!module)
      .map((module, i) => (
        // @ts-expect-error need to convert to TSX
        <ModuleIconStatus
          {...module}
          key={module.id || i}
          style={{
            transform: `translateX(-${i + 0.5}rem)`,
          }}
        />
      ));
  };

  return (
    <div className="module-icon-status-panel" style={{ marginRight: alignRight ? `${(MODULE_COUNT - modules.length - 1) * -1.5}rem` : 0 }}>
      {getPanel()}
    </div>
  );
};
